import { EventName } from '@lit/react';
import { BlocksDrawer } from 'blocks-nextjs/blocks-web-components/components/drawer/drawer';
import { BlocksCancelEvent, BlocksCloseEvent, BlocksOpenEvent } from 'blocks-nextjs/blocks-web-components/events';
import React from 'react';
import { createComponent } from '../CustomWrapper/CustomWrapper';

export const CatDrawer = createComponent({
  react: React,
  tagName: 'cat-drawer',
  elementClass: BlocksDrawer,
  events: {
    onBlDrawerOpen: 'bl-drawer-open' as EventName<BlocksOpenEvent>,
    onBlDrawerClose: 'bl-drawer-close' as EventName<BlocksCloseEvent>,
    onBlDrawerCancel: 'bl-drawer-cancel' as EventName<BlocksCancelEvent>
  }
});
